import SalesOfficeType from './SalesOfficeType'
import State from './State'
export class SalesOffice {
    ID: number;
    Name: string;
    Number: string;
    SalesOfficeTypeID: number;
    SalesOfficeType: SalesOfficeType;
    FullName: string;
    CrossDockSalesOfficeID?: number;
    CrossDockSalesOffice?: SalesOffice;
    CalendarCode: string;
    SalesOrg: string;
    FountainPlanningPlant: string;
    AML: string;
    CoolerAndVendorPlanningPlant: string;
    Inactive: boolean;
    EnhancedPaymentOptions: boolean;
    OffDayDeliveryFee: boolean;
    CrossDockOverride: boolean;
    StreetNumber: string;
    StreetName: string;
    City: string;
    StateID?: number;
    State?: State;
    PostalCode: string;
    Latitude?: number;
    Longitude?: number;
    County: string;
    MapRefID: string;
    TaxCode: string;
}

export default SalesOffice;